class CartRemoveButton extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', async (event) => {
			event.preventDefault();
			const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

			try {
				const cart = await cartItems.getCart();
				let variantIdData = this.querySelector('[data-variant-id]');
				console.log('variantIdData', variantIdData);
				let variantId = parseInt(variantIdData.dataset.variantId);
				console.log('variantId', variantId);

				const currentItem = cartItems.findItemWithPackage(cart.items, variantId);
				console.log('currentItem', currentItem);

				if (currentItem) {
					const itemsToBeRemoved = cartItems.getItemsWithSamePackage(cart.items, currentItem.properties._package);
					console.log('itemsToBeRemoved', itemsToBeRemoved);

					let updates = {};
					itemsToBeRemoved.forEach((item) => {
						updates[item.key] = 0;
					});

					cartItems.updateMultiQuantity(updates, this.dataset.index);
				} else {
					cartItems.updateQuantity(this.dataset.index, 0);
				}
			} catch (error) {
				console.error('Error retrieving or updating the cart:', error);
			}
		});
	}
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();
		this.lineItemStatusElement =
			document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

		const debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, ON_CHANGE_DEBOUNCE_TIMER);

		this.addEventListener('change', debouncedOnChange.bind(this));
	}

	findItemWithPackage(items, variantId) {
		return items.find((item) => {
			if (variantId) {
				return item.id === variantId && item.properties && item.properties._package;
			}
			return false;
		});
	}

	getItemsWithSamePackage(items, packageValue) {
		return items.filter((item) => item.properties && item.properties._package === packageValue);
	}

	async getCart() {
		try {
			const response = await fetch(`${routes.cart_url}.json`, { ...fetchConfig() });
			const cart = await response.json();
			return cart;
		} catch (error) {
			return console.error('Error fetching cart:', error);
		}
	}

	cartUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
			if (event.source === 'cart-items' || event.source === 'product-form') {
				return;
			}
			this.onCartUpdate();
		});
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber();
		}
	}

	async onChange(event) {
		const cart = await this.getCart();
		const line = event.target.dataset.index;
		const variantId = parseInt(event.target.dataset.quantityVariantId);

		const items = this.findItemWithPackage(cart.items, variantId);
		if (items) {
			const allItemsWithPackage = this.getItemsWithSamePackage(cart.items, items.properties._package);
			let updates = {};
			allItemsWithPackage.forEach((item) => {
				updates[item.variant_id] = event.target.value;
			});
			this.updateMultiQuantity(updates, line);
		} else {
			this.updateQuantity(
				event.target.dataset.index,
				event.target.value,
				document.activeElement.getAttribute('name'),
				event.target.dataset.quantityVariantId
			);
		}
	}

	onCartUpdate() {
		if (this.tagName === 'CART-DRAWER-ITEMS') {
			fetch(`${routes.cart_url}?section_id=cart-drawer`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html');
					const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
					// 1. Mémoriser l’état du dropdown promo
					const oldFooter = document.querySelector('.cart-drawer__footer');
					const wasOpen = oldFooter && oldFooter.classList.contains('mm-discount-open');

					for (const selector of selectors) {
						const targetElement = document.querySelector(selector);
						const sourceElement = html.querySelector(selector);
						if (targetElement && sourceElement) {
							targetElement.replaceWith(sourceElement);
						}
					}

					// 2. Réinitialiser le dropdown promo
					if (typeof mmInitDiscountDropdown === 'function') mmInitDiscountDropdown();

					// 3. Restaurer l’état ouvert si besoin
					if (wasOpen) {
						const newFooter = document.querySelector('.cart-drawer__footer');
						const newHeader = newFooter?.querySelector('.mm-discount-header');
						newFooter?.classList.add('mm-discount-open');
						newHeader?.classList.add('is-open');
					}
				})
				.catch((e) => {
					console.error(e);
				});
		} else {
			fetch(`${routes.cart_url}?section_id=main-cart-items`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html');
					const sourceQty = html.querySelector('cart-items');
					this.innerHTML = sourceQty.innerHTML;
				})
				.catch((e) => {
					console.error(e);
				});
		}
	}

	getSectionsToRender() {
		return [
			{
				id: 'main-cart-items',
				section: document.getElementById('main-cart-items').dataset.id,
				selector: '.js-contents',
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section',
			},
			{
				id: 'cart-live-region-text',
				section: 'cart-live-region-text',
				selector: '.shopify-section',
			},
			{
				id: 'main-cart-footer',
				section: document.getElementById('main-cart-footer').dataset.id,
				selector: '.js-contents',
			},
		];
	}

	updateMultiQuantity(updates, line) {
		this.enableLoading(line);

		const body = JSON.stringify({
			updates,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);

				if (parsedState.errors) {
					this.updateLiveRegions(line, parsedState.errors);
					return;
				}

				this.classList.toggle('is-empty', parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector('cart-drawer');
				const cartFooter = document.getElementById('main-cart-footer');

				if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
				if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector
					);
				});

				const items = document.querySelectorAll('.cart-item');
				if (parsedState.item_count === 0 && cartDrawerWrapper) {
					const emptyDrawer = cartDrawerWrapper.querySelector('.drawer__inner-empty');
					if (emptyDrawer) {
						trapFocus(emptyDrawer, cartDrawerWrapper.querySelector('a'));
					}
				} else if (items.length > 0 && cartDrawerWrapper) {
					trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
				}

				publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
			})
			.catch(() => {
				this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
				const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
				errors.textContent = window.cartStrings.error;
			})
			.finally(() => {
				this.disableLoading(line);
			});
	}

	updateQuantity(line, quantity, name, variantId) {
		this.enableLoading(line);

		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				const quantityElement =
					document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
				const items = document.querySelectorAll('.cart-item');

				if (parsedState.errors) {
					quantityElement.value = quantityElement.getAttribute('value');
					this.updateLiveRegions(line, parsedState.errors);
					return;
				}

				this.classList.toggle('is-empty', parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector('cart-drawer');
				const cartFooter = document.getElementById('main-cart-footer');

				if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
				if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector
					);
				});
				const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
				let message = '';
				if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
					if (typeof updatedValue === 'undefined') {
						message = window.cartStrings.error;
					} else {
						message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
					}
				}
				this.updateLiveRegions(line, message);

				const lineItem =
					document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper
						? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
						: lineItem.querySelector(`[name="${name}"]`).focus();
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					const emptyDrawer = cartDrawerWrapper.querySelector('.drawer__inner-empty');
					if (emptyDrawer) {
						trapFocus(emptyDrawer, cartDrawerWrapper.querySelector('a'));
					}
				} else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
					trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
				}

				publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
			})
			.catch(() => {
				this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
				const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
				errors.textContent = window.cartStrings.error;
			})
			.finally(() => {
				this.disableLoading(line);
			});
	}

	updateLiveRegions(line, message) {
		const lineItemError =
			document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
		if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

		this.lineItemStatusElement.setAttribute('aria-hidden', true);

		const cartStatus =
			document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
		cartStatus.setAttribute('aria-hidden', false);

		setTimeout(() => {
			cartStatus.setAttribute('aria-hidden', true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
		mainCartItems.classList.add('cart__items--disabled');

		const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
		const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute('aria-hidden', false);
	}

	disableLoading(line) {
		const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
		mainCartItems.classList.remove('cart__items--disabled');

		const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
		const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

		cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
		cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
	}
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
	customElements.define(
		'cart-note',
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					'input',
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
					}, ON_CHANGE_DEBOUNCE_TIMER)
				);
			}
		}
	);
}



// DISCOUNT CODE
function removeDiscount() {
	fetch(window.Shopify.routes.root + 'cart/update.js', {
	  method: 'POST',
	  headers: {
		'Content-Type': 'application/json'
	  },
	  body: JSON.stringify({ discount: '' })
	})
	  .then(res => res.json())
	  .then(data => {
		// Utiliser la fonction custom de rafraîchissement du panier
		mmOpenAndRefreshCart();
	  })
	  .catch(err => {
		console.error('Erreur lors du retrait du code promo :', err);
		alert('Erreur lors du retrait.', false);
	  });
  }
  
  /**
   * Attend que le code promo soit bien appliqué dans le panier (max retries).
   * @param {string} code - Le code promo à attendre.
   * @param {number} retries - Nombre d’essais restants.
   * @param {number} delay - Délai entre chaque essai (ms).
   * @returns {Promise}
   */
  function waitForDiscountInCart(code, retries = 10, delay = 300) {
	return new Promise((resolve, reject) => {
	  function check(remaining) {
		fetch('/cart.js')
		  .then(r => r.json())
		  .then(cart => {
			const found = cart.discount_codes.some(d => d.code.toLowerCase() === code && d.applicable);
			if (found) {
			  resolve();
			} else if (remaining > 0) {
			  setTimeout(() => check(remaining - 1), delay);
			} else {
			  reject('Le code promo n’a pas été appliqué à temps.');
			}
		  })
		  .catch(reject);
	  }
	  check(retries);
	});
  }
  
  async function mmApplyDiscountInCart() {
	const codeInput = document.getElementById('discount-code');
	const newCode = codeInput.value.trim().toLowerCase();
	const errorMessageText = codeInput.dataset.errorText;
	if (!newCode) return;
  
	// 1. Récupérer tous les codes déjà appliqués
	let previousCodes = [];
	try {
	  const cartBefore = await fetch('/cart.js').then(r => r.json());
	  // on ne garde que ceux applicables
	  previousCodes = cartBefore.discount_codes
		.filter(d => d.applicable)
		.map(d => d.code.toLowerCase());
	} catch (err) {
	  console.error('Impossible de récupérer les codes existants', err);
	}
  
	// 2. Ajouter le produit lié si besoin (comme avant)
	const hiddenInputs = document.querySelectorAll('.mm-hgjfidu');
	let matchedVariantId = null;
	hiddenInputs.forEach(input => {
	  if (atob(input.value).toLowerCase() === newCode) {
		matchedVariantId = input.dataset.variantId;
	  }
	});
	if (matchedVariantId) {
	  try {
		await fetch(window.Shopify.routes.root + 'cart/add.js', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ id: matchedVariantId, quantity: 1 })
		}).then(r => r.json());
	  } catch (err) {
		console.error('Erreur ajout produit promo', err);
	  }
	}
  
	// 3. Composer la liste complète de codes à appliquer
	const allCodes = Array.from(new Set([...previousCodes, newCode]));
	const discountString = allCodes.join(',');
  
	// 4. Tenter d’appliquer tous les codes
	try {
	  await fetch(window.Shopify.routes.root + 'cart/update.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ discount: discountString })
	  });
  
	  // 5. Vérifier si le nouveau code a été appliqué
	  const cartAfter = await fetch('/cart.js').then(r => r.json());
	  const appliedCodes = cartAfter.discount_codes.map(d => ({
		code: d.code.toLowerCase(),
		ok: d.applicable
	  }));
	  const newCodeResult = appliedCodes.find(d => d.code === newCode);
  
	  if (newCodeResult && newCodeResult.ok) {
		// On attend que le code promo soit bien visible dans le panier avant de rafraîchir le drawer
		waitForDiscountInCart(newCode, 10, 300)
		  .then(() => {
			mmOpenAndRefreshCart();
		  })
		  .catch(() => {
			// Si jamais le code n'est pas visible après 10 essais, on force le refresh
			mmOpenAndRefreshCart();
		  });
	  } else {
		// échec pour le nouveau code
		displayPromoError(errorMessageText);
  
		// 6. Réappliquer **seulement** les anciens codes
		if (previousCodes.length) {
		  await fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ discount: previousCodes.join(',') })
		  });
		}
	  }
	} catch (err) {
	  console.error('Erreur lors de l’application des codes promo', err);
	  displayPromoError('Une erreur est survenue. Veuillez réessayer.');
	  // on ne touche pas aux codes déjà en place
	}
  }
  
  // Affiche un message d’erreur sous le formulaire
  function displayPromoError(message) {
	let errorElem = document.querySelector('.promo-error');
	if (!errorElem) {
	  errorElem = document.createElement('div');
	  errorElem.className = 'promo-error text-xs text-red-600 mt-2';
	  const form = document.getElementById('discount-form') || document.body;
	  form.appendChild(errorElem);
	}
	errorElem.textContent = message;
  }
  
  // DROPDOWN CODE PROMO
  
  function mmInitDiscountDropdown() {
	// On évite d'attacher plusieurs fois le même listener
	if (window._mmDiscountDropdownInit) return;
	window._mmDiscountDropdownInit = true;
  
	document.body.addEventListener('click', function (e) {
	  const discountHeader = e.target.closest('.mm-discount-header');
	  if (discountHeader) {
		const parent = discountHeader.closest('.cart-drawer__footer');
		if (parent) {
		  const isOpen = parent.classList.toggle('mm-discount-open');
		  discountHeader.classList.toggle('is-open', isOpen);
		}
	  }
	});
  }
  
  document.addEventListener('DOMContentLoaded', function () {
	mmInitDiscountDropdown();
  });
  
  /**
   * Rafraîchit le contenu du panier et ouvre le drawer (cart) avec les dernières données.
   */
  function mmOpenAndRefreshCart() {
	// 1. Mémoriser l’état du dropdown
	const footer = document.querySelector('.cart-drawer__footer');
	const wasOpen = footer && footer.classList.contains('mm-discount-open');
  
	fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`)
	  .then((response) => response.text())
	  .then((responseText) => {
		const html = new DOMParser().parseFromString(responseText, 'text/html');
		// Remplacement des éléments principaux du drawer
		const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
		for (const selector of selectors) {
		  const targetElement = document.querySelector(selector);
		  const sourceElement = html.querySelector(selector);
		  if (targetElement && sourceElement) {
			targetElement.replaceWith(sourceElement);
		  }
		}
		// Réinitialisations nécessaires
		if (typeof mmInitDiscountDropdown === 'function') mmInitDiscountDropdown();
		if (typeof mmInitSplideCross === 'function') mmInitSplideCross();
		if (typeof initAccordions === 'function') initAccordions();
		if (typeof mmSetupCartProductForm === 'function') mmSetupCartProductForm();
		if (typeof updateCartCount === 'function') updateCartCount();
		if (typeof mmInitDiscounts === 'function') mmInitDiscounts();
		if (typeof mmOpenCart === 'function') mmOpenCart();
  
		// 2. Restaurer l’état ouvert si besoin
		if (wasOpen) {
		  const newFooter = document.querySelector('.cart-drawer__footer');
		  const newHeader = newFooter?.querySelector('.mm-discount-header');
		  newFooter?.classList.add('mm-discount-open');
		  newHeader?.classList.add('is-open');
		}
	  })
	  .catch((err) => {
		console.error('Erreur lors du rafraîchissement du panier :', err);
	  });
  }